module.exports = __webpack_public_path__ + "img/temp-bar-graph.6ced166e.png";